export default {
  appId: process.env.REACT_APP_ALGOLIA_APP_ID || null,
  apiKey: process.env.REACT_APP_ALGOLIA_API_KEY || null
}
